/* global Twine */

export class FrameRenderHandler {
  static onEvent(event) {
    const {
      detail: { response },
    } = event;

    new FrameRenderHandler({ document, event, response }).onEvent();
  }

  constructor({ document, event, response }) {
    this.document = document;
    this.event = event;
    this.response = response;
  }

  onEvent() {
    if (this.event.target.dataset.turboFrameEvalTwine === 'true') {
      const nodes = this.event.target.querySelectorAll('[eval]');

      if (nodes.length > 0) {
        nodes.forEach((node) => {
          Twine.bind(node);
        });
        Twine.refresh();
      }
    }
  }
}
